import EmployeeDetails from './EmployeeDetailsContainer';

export default EmployeeDetails;
